module.exports = __webpack_public_path__ + "static/media/graph.9b1f9337.jpg";